<template>
    <div class="about-page  page">
        <div class="my-container">
            <div class="row">
                <h1 class="header">{{ t('aboutUs') }}</h1>
                <p class="description">
                    {{ about['section-1'].description[locale] }}
                </p>
            </div>
            <img :src="about['section-1'].media_file[locale]" alt="eclair" class="banner"
                v-if="about['section-1'].media_file_type === 'image'" />
            <video controls v-else>
                <source :src="about['section-1'].media_file[locale]" type="video/mp4" />
            </video>
            <h2 class="header">{{ t('companyHistory') }}</h2>
            <div class="history-2">
                <div>
                    <div class="entry" v-for="(entry, i) in about['history-of-company'].items"
                        :style="`anchor-name: --history-${i}; position-anchor: --history-${i - 1}`">
                        <div class="title">
                            {{ entry.title }}
                        </div>
                        <p class="description">
                            {{ entry.description[locale] }}
                        </p>
                        <img :src="entry.media_file" alt="">
                    </div>
                    <div class="helper" v-if="about['history-of-company'].items.length % 2 === 0" style="height: 100px">
                    </div>
                </div>
                <div></div>
            </div>
            <div class="row">
                <h2 class="header">{{ t('philosophy') }}</h2>
                <p class="description">
                    {{ about.philosophy.description[locale] }}
                </p>
            </div>
            <img class="philosophy-banner" :src="about.philosophy.media_file" alt=""
                v-if="about.philosophy.media_file_type === 'image'">
            <video controls v-else>
                <source :src="about.philosophy.media_file" type="video/mp4" />
            </video>
        </div>
        <div class="advantages" :style="`background: url('${about.advantages.media_file}') no-repeat center center/cover;     background-attachment: fixed;
`">
            <div class="overlay">
                <div class="my-container">
                    <h2 class="header"> {{ t('advantages') }}</h2>
                    <ul class="advantage-list">
                        <li class="advantage-entry" v-for="adv in about.advantages.items" :key="adv.title[locale]">
                            <div class="title">{{ adv.title[locale] }}</div>
                            <p class="description">{{ adv.description[locale] }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const { locale, t } = useI18n();
const rc = useRuntimeConfig()
const about = ref((await $fetch(rc.public.api + '/api/sections/about')).data)
const left = computed(
    () => about.value['history-of-company'].items.filter((el, i) => i % 2 === 0)
)
const right = computed(
    () => about.value['history-of-company'].items.filter((el, i) => i % 2 === 1)
)

</script>
